import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Auth } from 'aws-amplify';

import { useInterval } from "../hooks/useInterval";

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import Banner from '../components/layout/Banner';

const CircularProgressWithLabel = (props) => {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="static" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="h6" component="div" color="textPrimary">{props.label}</Typography>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10)
  },
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(6)
  },
  msg: {
    marginTop: '12px',
    color: theme.palette.error.main
  },
  progress: {
    marginTop: '8px'
  },
  label: {
    paddingTop: theme.spacing(5)
  },
  buttons: {
    marginTop: theme.spacing(1)
  },
  formGroup: {
    marginTop: theme.spacing(1)
  }
}));

const Register = (props) => {
  const [user, setUser] = useState();
  const [code, setCode] = useState("");

  const [firstname, setFirstname] = useState("");
  const [surname, setSurname] = useState("");
  const [organisation, setOrganisation] = useState("");
  const [locale, setLocale] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [member, setMember] = useState("");
  const [nominee, setNominee] = useState("");
  const [registrar, setRegistrar] = useState("");
  const [chartered, setChartered] = useState("");
  const [membership, setMembership] = useState("");
  const [consent, setConsent] = useState("");

  const [errorFirstname, setErrorFirstname] = useState("");
  const [errorSurname, setErrorSurname] = useState("");
  const [errorOrganisation, setErrorOrganisation] = useState("");
  const [errorLocale, setErrorLocale] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [errorPassword2, setErrorPassword2] = useState("");
  const [errorMember, setErrorMember] = useState("");
  const [errorNominee, setErrorNominee] = useState("");
  const [errorConsent, setErrorConsent] = useState("");

  const [formMsg, setFormMsg] = useState("");
  const [isWaiting, setIsWaiting] = useState(false);
  const [codeSentAt, setCodeSentAt] = useState(0);
  const [progessLabel, setProgressLabel] = useState(0);
  const [progressValue, setProgressValue] = useState(0);

  const history = useHistory();

  const validateRegistrationForm = () => {
    setFormMsg("Please correct your details ...");
    setErrorFirstname("");
    setErrorSurname("");
    setErrorOrganisation("");
    setErrorLocale("");
    setErrorEmail("");
    setErrorPassword("");
    setErrorPassword2("");
    setErrorMember("");
    setErrorNominee("");
    setErrorConsent("");

    if (firstname.length === 0) {
      setErrorFirstname("Enter your first name.");
      return false;
    }
    if (surname.length === 0) {
      setErrorSurname("Enter your surname.");
      return false;
    }
    if (organisation.length === 0) {
      setErrorOrganisation("Enter your Organisation.");
      return false;
    }
    if (locale.length === 0) {
      setErrorLocale("Select your State.");
      return false;
    }
    if (email.length === 0) {
      setErrorEmail("Enter an email address.");
      return false;
    }
    if (email.length === 0) {
      setErrorEmail("Enter an email address.");
      return false;
    }
    if (email.indexOf("@") === -1 || email.length <= 3) {
      setErrorEmail("Enter a valid email address.");
      return false;
    }
    if (password.length === 0) {
      setErrorPassword("Enter a password.");
      return false;
    }
    if (password !== password2) {
      setErrorPassword2("Your passwords do not match.");
      return false;
    }
    if (member.length === 0) {
      setErrorMember("Select an answer.");
      return false;
    }
    if (nominee.length === 0) {
      setErrorNominee("Select an answer.");
      return false;
    }

    setFormMsg("");
    return true;
  };

  const validateConfirmationForm = () => {
    if (code.length === 0) {
      setFormMsg("Please enter the activation code.");
      return false;
    }
    var regex = new RegExp('^[0-9]+$');
    if (!regex.test(code)) {
      setFormMsg("Please enter a valid code. Your activation code should be a 6 digit number.");
      return false;
    }
    return true;
  }

  const handleRegistrationSubmit = async (event) => {
    event.preventDefault();

    let subs = [];
    if (registrar) subs.push('registrar');
    if (chartered) subs.push('chartered');
    if (membership) subs.push('membership');
    let subscribe = '';
    if (subs.length > 0)
      subscribe = subs.join(', ');
    console.log('subscribe', subscribe);

    if (validateRegistrationForm()) {
      setIsWaiting(true);
      setFormMsg("Registering ...");
      try {
        const user = await Auth.signUp({
          username: email,
          password: password,
          attributes: {
            email: email,
            given_name: firstname,
            family_name: surname,
            locale: locale,
            'custom:organisation': organisation,
            'custom:member': member,
            'custom:nominee': nominee,
            'custom:subscribe': subscribe,
            'custom:consent': consent
          }
        });
        setUser(user);
        setCodeSentAt(new Date().getTime());
        setProgressValue(100);
        setProgressLabel(15);
        setFormMsg("Please check your email inbox, and enter the activation code ...");
        setIsWaiting(false);
      } catch (e) {
        console.log(e.message);
        setFormMsg(e.message);
        setIsWaiting(false);
      }
    }
  };

  const handleConfirmationSubmit = async (event) => {
    event.preventDefault();

    if (validateConfirmationForm()) {
      setIsWaiting(true);
      setFormMsg("Activating account ...");

      try {
        await Auth.confirmSignUp(email, code);
        const user = await Auth.signIn(email, password);
        setUser(user);
        setFormMsg("");
        setIsWaiting(false);
        history.push("/event");
      } catch (e) {
        console.log(e.message);
        setFormMsg(e.message);
        setIsWaiting(false);
      }
    }
  };

  const handleResendCode = async event => {
    setIsWaiting(true);
    setFormMsg("Sending Activation Code ...");
    try {
      setCodeSentAt(new Date().getTime());
      setProgressValue(100);
      setProgressLabel(15);
      await Auth.resendSignUp(email);
      setIsWaiting(false);
      setFormMsg("Please check your email inbox, and enter the activation code ...");
    } catch (e) {
      console.log(e.message);
      setFormMsg(e.message);
      setIsWaiting(false);
    }
  };

  useInterval(() => {
    const duration = 15 * 60 * 1000; // 15 minutes
    if (codeSentAt > 0) {
      const diff = (codeSentAt + duration) - new Date().getTime();
      if (diff > 0 && diff < duration) {
        setProgressValue(Math.round((diff / duration) * 100));
        setProgressLabel(Math.round(diff / 60 / 1000));
      } else {
        setProgressValue(0);
        setProgressLabel(0);
      }
    }
  }, 5000);

  const renderRegistrationForm = (props) => {
    return (
      <Paper className={classes.paper}>
        <h2>Register</h2>
        <form noValidate autoComplete="off" onSubmit={handleRegistrationSubmit}>

          <Grid container spacing={1}>
            <Grid item sm={6}>
              <TextField
                id="firstname"
                label="First name"
                value={firstname}
                error={errorFirstname.length > 0}
                helperText={errorFirstname}
                onChange={e => setFirstname(e.target.value)}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
                autoFocus
              />
            </Grid>
            <Grid item sm={6}>
              <TextField
                id="surname"
                label="Surname"
                value={surname}
                error={errorSurname.length > 0}
                helperText={errorSurname}
                onChange={e => setSurname(e.target.value)}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item sm={6}>
              <TextField
                id="organisation"
                label="Organisation"
                value={organisation}
                error={errorOrganisation.length > 0}
                helperText={errorOrganisation}
                onChange={e => setOrganisation(e.target.value)}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
                autoFocus
              />
            </Grid>
            <Grid item sm={6}>
              <TextField
                select
                id="locale"
                label="State"
                value={locale}
                error={errorLocale.length > 0}
                helperText={errorLocale}
                onChange={e => setLocale(e.target.value.trim())}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
              >
                <MenuItem value='NSW'> New South Wales </MenuItem>
                <MenuItem value='VIC'> Victoria </MenuItem>
                <MenuItem value='QLD'> Queensland </MenuItem>
                <MenuItem value='SA'> South Australia </MenuItem>
                <MenuItem value='WA'> Western Australia </MenuItem>
                <MenuItem value='TAS'> Tasmania </MenuItem>
                <MenuItem value='NT'> Northern Territory </MenuItem>
                <MenuItem value='ACT'> Australian Capital Territory </MenuItem>
              </TextField>
            </Grid>
          </Grid>

          <TextField
            id="email"
            label="Email"
            value={email}
            error={errorEmail.length > 0}
            helperText={errorEmail}
            onChange={e => setEmail(e.target.value.trim().toLowerCase())}
            margin="normal"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            fullWidth
            autoFocus
          />
          <TextField
            id="password"
            label="Password"
            type="password"
            value={password}
            error={errorPassword.length > 0}
            helperText={errorPassword}
            onChange={e => setPassword(e.target.value)}
            margin="normal"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <TextField
            id="password2"
            label="Confirm Password"
            type="password"
            value={password2}
            error={errorPassword2.length > 0}
            helperText={errorPassword2}
            onChange={e => setPassword2(e.target.value)}
            margin="normal"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <FormHelperText className={classes.helper}>Your password must contain uppercase letters, lowercase letters, special characters, numbers and be at least 8 characters in length.</FormHelperText>

          <Grid container spacing={1}>
            <Grid item sm={6}>
              <div className={classes.label}><FormLabel>Are you a member of <b>Engineers Australia</b>?</FormLabel></div>
              <TextField
                select
                id="member"
                label="Member"
                value={member}
                error={errorMember.length > 0}
                helperText={errorMember}
                onChange={e => setMember(e.target.value.trim())}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
                autoFocus
              >
                <MenuItem value=''> </MenuItem>
                <MenuItem value='yes'> Yes </MenuItem>
                <MenuItem value='no'> No </MenuItem>
              </TextField>
            </Grid>
            <Grid item sm={6}>
              <div className={classes.label}><FormLabel>Are you a current <b>nominee</b>?</FormLabel></div>
              <TextField
                select
                id="nominee"
                label="Nominee"
                value={nominee}
                error={errorNominee.length > 0}
                helperText={errorNominee}
                onChange={e => setNominee(e.target.value.trim())}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
              >
                <MenuItem value=''> </MenuItem>
                <MenuItem value='yes'> Yes </MenuItem>
                <MenuItem value='no'> No </MenuItem>
              </TextField>
            </Grid>
          </Grid>

          <div className={classes.label}><FormLabel >Would you be interested in learning more about the benefits of:</FormLabel></div>
          <FormGroup className={classes.formGroup}>
            <FormControlLabel label="EA Membership" control={<Checkbox checked={membership} onChange={e => setMembership(e.target.checked)} name="membership" />} />
            <FormControlLabel label="Becoming Chartered" control={<Checkbox checked={chartered} onChange={e => setChartered(e.target.checked)} name="chartered" />} />
            <FormControlLabel label="Joining EA's National Engineering Register" control={<Checkbox checked={registrar} onChange={e => setRegistrar(e.target.checked)} name="registrar" />} />
          </FormGroup>

          <Grid container>
            <Grid item lg={8}>
              <div className={classes.label}><FormLabel>I consent to Engineers Australia using my contact information (including my name and email address) to contact me about any future events, networking and industry updates.</FormLabel></div>
              <TextField
                select
                id="consent"
                label="Consent"
                value={consent}
                error={errorConsent.length > 0}
                helperText={errorConsent}
                onChange={e => setConsent(e.target.value.trim())}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
              >
                <MenuItem value=''> </MenuItem>
                <MenuItem value='yes'> Yes </MenuItem>
                <MenuItem value='no'> No </MenuItem>
              </TextField>
            </Grid>
          </Grid>

          <Grid container className={classes.buttons} spacing={6}>
            <Grid item>
              <Button type="submit" variant="contained" color="primary" disabled={isWaiting}>
                Submit
            </Button>
            </Grid>
            <Grid item>
              {isWaiting && (
                <CircularProgress size={20} className={classes.progress} />
              )}
            </Grid>
            <Grid item>
              <h5 className={classes.msg}>{formMsg}</h5>
            </Grid>
          </Grid>

        </form>
      </Paper>
    );
  };

  const renderConfirmationForm = (props) => {
    return (
      <>
        <Paper className={classes.paper}>
          <h2>Activate Account</h2>
          <p>Please check your email inbox: <b>{email}</b><br />(and spam folder) for the activation code.</p>
          <form noValidate autoComplete="off" onSubmit={handleConfirmationSubmit}>
            <TextField
              id="code"
              label="Activation Code"
              value={code}
              type="tel"
              onChange={e => setCode(e.target.value.trim())}
              margin="normal"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              fullWidth
              autoFocus
            />
            <Grid container className={classes.buttons} spacing={6}>
              <Grid item>
                <Button type="submit" variant="outlined" color="primary" disabled={isWaiting}>
                  Submit
            </Button>
              </Grid>
              <Grid item>
                {isWaiting && (
                  <CircularProgress size={20} className={classes.progress} />
                )}
              </Grid>
              <Grid item>
                <h5 className={classes.msg}>{formMsg}</h5>
              </Grid>
            </Grid>
          </form>
        </Paper>

        <Paper className={classes.paper}>
          <h3>Activation Code</h3>
          <p>An activation code has been sent to your inbox: <b>{email}</b>.</p>
          <p>If you are unable to find this email please also check your junk email and spam folder.</p>
          <Grid container justify="space-between" alignItems="flex-end">
            <Grid item>
              <p>This activation code is valid for 15 minutes.</p>
              <Button variant="outlined" color="primary" onClick={handleResendCode} className={classes.button}>Re-send Activation Code</Button>
            </Grid>
            <Grid item>
              {progressValue > 0 &&
                <CircularProgressWithLabel color="secondary" size={60} value={progressValue} label={progessLabel} />
              }
            </Grid>
          </Grid>
        </Paper>
      </>
    );
  }

  const classes = useStyles();
  return (
    <>
      <Banner isAuthenticated={props.isAuthenticated} Logout={props.Logout} />
      <Container>
        <Grid container justify='center' className={classes.root}>
          <Grid item xs={12} sm={12} md={8} lg={7}>
            {user ? renderConfirmationForm() : renderRegistrationForm()}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Register;